module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-smart-life-box-title-logo-c7de22899b490af9f9f2301946ec86a8.png";